import ContentLayout from '@/layouts/content-layout'
import PrivilegeFormView from '@/sections/privilege/view/privilege-form-view'

export default function PrivilegeForm() {
  return (
    <ContentLayout title="ของรางวัล" backButton>
      <PrivilegeFormView />
    </ContentLayout>
  )
}
